import dayjs from "dayjs";
import { readLocalEnv } from '@dhbfront-utils/domain'

// if (process.env.NODE_ENV === 'development') {
//   debugger
//   readLocalEnv({ domainConfigRequire: require('../local/domainConfig.js'), projectConfigRequire: require('../local/projectConfig.js') })
//   require('@dhbfront-utils/mock/dist/browerHttpIntercept').browserHttpIntercept(window)

// }
// let apiUrl = window.location.origin.replace('data', 'api');
let apiUrl = domainConfig.hosts["dhb168-api"]
// let pcApiUrl = window.location.origin.replace('data', 'admin');
let pcApiUrl = domainConfig.hosts["dhb168-admin"]
let orderApiUrl = domainConfig.hosts["bff-order"]
let chatApiUrl = domainConfig.hosts["releated-dify-chat"]
if (window.location.origin.indexOf('local.newdhb') > -1) {
  orderApiUrl = 'http://bff-order.newdhb.com';
  pcApiUrl = 'http://manager.newdhb.com';
  chatApiUrl = 'http://chat.newdhb.com';
  apiUrl = 'http://api.newdhb.com';
}
if (window.location.origin.indexOf('dhb168') > -1 && process.env.NODE_ENV === 'development') {
  orderApiUrl = '/ybffOrder';
  pcApiUrl = '/yadmin';
  chatApiUrl = '/ychat';
  apiUrl = '/yapi';
}

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}
export const isH5 = isMobile() || window.screen.availWidth < 768;
export const isPc = !isH5;

// 接口地址
export const DHB_API_MOBILE = apiUrl + '';
export const DHB_API_ORDER = orderApiUrl;
export const DHB_API_PC = pcApiUrl;
export const DHB_API_CHAT = chatApiUrl;

// export const getEnv = ()=>{
//   switch (window.location.host){
//     case 'data.dhb168.com':
//       return 'production';
//     case 'ydata.dhb168.com':
//       return 'release';
//     case 'data.newdhb.com':
//       return 'stage'
//     default: 
//       return 'development'
//   }
// }


export const sessionStorageCustom = {
  setItem(storageKey:string,data:any){
    window.sessionStorage.setItem(storageKey,JSON.stringify(data))
  },
  getItem<T>(storageKey:string){
    let dataString = window.sessionStorage.getItem(storageKey);
    let data: T | undefined = undefined
    if (dataString) {
      try {
        data = JSON.parse(dataString);
      } catch (e) {
        console.error(e)
      }
    }
    return data
  }
}
export class StorageCustomInstance<T = any>{
  key = ''
  constructor(options?:{key?:string,stroageType: 'session'} ){
    const { key } = options || {}
    if(key){
      this.key = key
    }
  }
  updateKey(key:string){
    this.key = key
  }
  setItem(data:T){
    sessionStorageCustom.setItem(this.key!,JSON.stringify(data));
  }
  getItem(){
    return sessionStorageCustom.getItem<T>(this.key);
  }
}


export function omitEmptyValue<T extends Record<string,any>>(obj:T){
  let newObj = {} as T
  Object.keys(obj).forEach((key: keyof T)=>{
    let val = obj[key]
    if(val || val === 0){
      newObj[key] = val as T[keyof T]
    }
  })
  return newObj
}


const dataAnalysisSkey = 'dataAnalysisSkey'
const appInfoKey = 'appInfoKey'

export function setMobileSkey (skey:string){
  window.localStorage.setItem(dataAnalysisSkey,skey)
}
export function getMobileSkey (){
  let  appInfo = getAppInfo()
  return appInfo.skey
}


type Appinfo = {
  from?:'ios'|'android'|'h5'
  skey?:string
  statusBarHeight?:string
}

export const getAppInfo = ():Appinfo=>{
  try{
    let appInfoString = window.localStorage.getItem(appInfoKey) || '{}'
    return JSON.parse(appInfoString)
  }catch(e){
    return {}
  }
  return {}
}
export const extractAppInfo = () =>{
  let searchs = Object.fromEntries(new URLSearchParams(window.location.search));
  let appinfo:Appinfo = {}
  if (searchs.skey) {
    appinfo.skey = searchs.skey
    appinfo.from = searchs.from as any
    appinfo.statusBarHeight = searchs.statusBarHeight
    window.localStorage.setItem(appInfoKey,JSON.stringify(appinfo))
  }
}
export const goBackApp = ()=>{
  let  appInfo = getAppInfo()
  if(appInfo.from  == 'ios'){
    window.location.href = 'dhb://back';
    return
  }
  if(appInfo.from == 'android'){
    backapp.back();
  }
}


export const getAppSafeTopArea = ()=>{
  let  appInfo = getAppInfo()
  let statusBarHeight = appInfo.statusBarHeight
  if(appInfo.from  == 'ios'){
    return Number(statusBarHeight) + 'px'
  }
  if(appInfo.from == 'android'){
    return Number(statusBarHeight) / window.devicePixelRatio + 'px'
  }
  return 30
}

export const DateLimitCalculator = {
  /**
   * 计算整年限制的日期
   * @param {Number} years 年数限制（包括当前年）
   * @returns {Moment} 限制日期
   */
  calculateWholeYearLimit: (years:number) => {
    
      const currentYear =  dayjs().year();
      // 当前年也算一年，所以减去(years-1)
      const limitYear = currentYear - (years - 1);
      return dayjs(`${limitYear}-01-01`, 'YYYY-MM-DD');
  },
  
  /**
   * 根据时间单位和数量计算限制日期
   * @param {String} limitStr 格式如"3y"、"3m"、"3d"
   * @returns {Moment} 限制日期
   */
  calculateLimitByUnit: (limitStr:string) => {
      if (!limitStr) return null;
      
      const match = limitStr.match(/^(\d+)([ymd])$/);
      if (!match) return null;
      
      const [, value, unit] = match;
      const numValue = parseInt(value, 10);
      const currentDate = dayjs();
      
      switch(unit) {
          case 'y': // 年
              return dayjs(`${currentDate.year() - (numValue - 1)}-01-01`, 'YYYY-MM-DD');
          case 'm': // 月
              return currentDate.clone().subtract(numValue, 'months');
          case 'd': // 天
              return currentDate.clone().subtract(numValue, 'days');
          default:
              return null;
      }
  },
  calculateEndDateLimit: (enabledEndDate: string) => {
    const match = enabledEndDate.match(/^(\d+)([ymd])$/);
    if (!match) return null;
    
    const [, value, unit] = match;
    const numValue = parseInt(value, 10);
    
    if (unit === 'y') {
      // 对于年份限制，计算numValue年前的年末(12月31日)
      const limitYear = dayjs().year() - numValue;
      return dayjs(`${limitYear}-12-31`).endOf('day');
    }
    
    // 其他单位可以按需扩展
    return null;
  },
  limitDate: (current:dayjs.Dayjs,startTimeMax:string) => {
    const limitDate = DateLimitCalculator.calculateLimitByUnit(startTimeMax);
      if (current && limitDate && current.valueOf() < limitDate.valueOf()) {
          return true;
      }
  }
};

/**
 * 日期禁用处理器
 */
export interface DateDisabledOptions {
  isStartDay?: boolean;
  isEndDay?: boolean;
  enabledStartDate?: string;
  enabledEndDate?: string;
  startDateValue?: string; // 开始日期的值，用于结束日期的约束
}

export const DateDisabledHandler = {
  /**
   * 根据enabledEndDate计算结束日期限制
   * @param enabledEndDate 限制字符串，如'3y'
   * @returns 限制日期
   */
  calculateEndDateLimit: (enabledEndDate: string) => {
    const match = enabledEndDate.match(/^(\d+)([ymd])$/);
    if (!match) return null;
    
    const [, value, unit] = match;
    const numValue = parseInt(value, 10);
    
    if (unit === 'y') {
      // 对于年份限制，计算numValue年前的年末(12月31日)
      const limitYear = dayjs().year() - numValue;
      return new Date(`${limitYear}-12-31 23:59:59`);
    } else {
      // 对于月和日的限制，使用原有逻辑
      return DateLimitCalculator.calculateLimitByUnit(enabledEndDate);
    }
  },

  /**
   * 创建日期禁用函数
   * @param options 配置选项
   * @returns 禁用函数
   */
  createDisabledDate: (options: DateDisabledOptions) => {
    const { isStartDay, isEndDay, enabledStartDate, enabledEndDate, startDateValue } = options;
    
    return (current: dayjs.Dayjs | null) => {
      if (!current) return false;
      
      // 处理开始时间的限制
      if (isStartDay && enabledStartDate) {
        const startLimitDate = DateLimitCalculator.calculateLimitByUnit(enabledStartDate || '3y');
        if (startLimitDate && current.valueOf() < startLimitDate.valueOf()) {
          return true;
        }
      }
      
      // 处理结束时间基于开始时间的限制
      if (isEndDay && enabledStartDate) {
        const startLimitDate = DateLimitCalculator.calculateLimitByUnit(enabledStartDate || '3y');
        // 不能选择早于开始日期的时间
        if (startDateValue && current.valueOf() < dayjs(startDateValue).valueOf()) {
          return true;
        }
        // 不能选择早于起始限制日期的时间
        if (startLimitDate && current.valueOf() < startLimitDate.valueOf()) {
          return true;
        }
      }
      
      // 处理结束时间基于enabledEndDate的限制
      if (isEndDay && enabledEndDate) {
        const endLimitDate = DateDisabledHandler.calculateEndDateLimit(enabledEndDate);
        // 禁用endLimitDate之后的日期
        if (endLimitDate && current.valueOf() > endLimitDate.valueOf()) {
          return true;
        }
        // 不能选择早于开始日期的时间
        if (startDateValue && current.valueOf() < dayjs(startDateValue).valueOf()) {
          return true;
        }
      }
      
      return false;
    };
  }
};